import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import query from './query.graphql';
export var useNotifications = function () {
    var _a = useQuery(query), data = _a.data, error = _a.error, loading = _a.loading;
    var smsLeft = useMemo(function () {
        if (!data)
            return 0;
        return data.getSMSLeft.free + data.getSMSLeft.paid;
    }, [data]);
    var values = useMemo(function () { return ({
        smsLeft: smsLeft,
        loading: loading,
        error: error,
    }); }, [smsLeft, loading, error]);
    return values;
};
